
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class UtentiProdottiParametriGlobaliDialog extends Serenity.EntityDialog<UtentiProdottiParametriGlobaliRow, any> {
        protected getFormKey() { return UtentiProdottiParametriGlobaliForm.formKey; }
        protected getIdProperty() { return UtentiProdottiParametriGlobaliRow.idProperty; }
        protected getLocalTextPrefix() { return UtentiProdottiParametriGlobaliRow.localTextPrefix; }
        protected getNameProperty() { return UtentiProdottiParametriGlobaliRow.nameProperty; }
        protected getService() { return UtentiProdottiParametriGlobaliService.baseUrl; }
        protected getDeletePermission() { return UtentiProdottiParametriGlobaliRow.deletePermission; }
        protected getInsertPermission() { return UtentiProdottiParametriGlobaliRow.insertPermission; }
        protected getUpdatePermission() { return UtentiProdottiParametriGlobaliRow.updatePermission; }

        protected form = new UtentiProdottiParametriGlobaliForm(this.idPrefix);

        protected getToolbarButtons() {
            let buttons = super.getToolbarButtons();

            //Remove Button
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 1);

            //
            if (Q.Authorization.hasPermission("Role:SuperAdmin")) {
                //Remove Button
                buttons.splice(Q.indexOf(buttons, x => x.cssClass == "delete-button"), 1);

                //Remove Button
                buttons.splice(Q.indexOf(buttons, x => x.cssClass == "save-and-close-button"), 1);
            }

            return buttons;
        }
    }
}